export type VersionForm = {
  template: string;
  llmId: string;
  outputSchema: string;
  temperature: string;
  maxTokens: string;
  notes: string;
};

/** A free-text schema is the required database representation of no constraint. */
export function schemaText(schema: Record<string, unknown> | null): string {
  return !schema || (Object.keys(schema).length === 1 && schema.type === "string")
    ? "" : JSON.stringify(schema, null, 2);
}

/** Empty optional controls explicitly clear; omission would retain old values. */
export function versionUpdate(form: VersionForm) {
  if (!form.llmId) throw new Error("Choose a model for this version.");
  let output_schema: Record<string, unknown> | null = null;
  if (form.outputSchema.trim()) {
    try {
      const parsed: unknown = JSON.parse(form.outputSchema);
      if (parsed === null || Array.isArray(parsed) || typeof parsed !== "object") throw new Error("Use a JSON object.");
      output_schema = parsed as Record<string, unknown>;
    } catch (error) {
      throw new Error(`Output schema is not a valid JSON object: ${error instanceof Error ? error.message : "invalid JSON"}`);
    }
  }
  const numeric = (input: string, label: string) => {
    if (!input.trim()) return null;
    const value = Number(input);
    if (!Number.isFinite(value)) throw new Error(`${label} must be a number.`);
    return value;
  };
  return { template: form.template, llm_id: form.llmId, output_schema,
    temperature: numeric(form.temperature, "Temperature"), max_tokens: numeric(form.maxTokens, "Max tokens"),
    notes: form.notes.trim() ? form.notes : null };
}
